// Common GraphQL fragments used across multiple services

// Pagination fields used in list queries
export const PAGINATION_FRAGMENT = `
  limit
  page
  total
  totalDocs
  totalPage
  totalPages
  hasNextPage
  hasPrevPage
  offset
`;

// Common timestamp fields
export const TIMESTAMP_FRAGMENT = `
  createdAt
  updatedAt
`;

// Common ID and timestamp combination
export const BASE_FIELDS_FRAGMENT = `
  id
  ${TIMESTAMP_FRAGMENT}
`;

// Common media/avatar fields
export const MEDIA_FRAGMENT = `
  id
  url
  alt
  filename
`;

// Address fields
export const ADDRESS_FRAGMENT = `
  streetAddress
  displayedAddress
  city
  province
  country
  zipCode
`;

// Query params/meta information
export const QUERY_PARAMS_FRAGMENT = `
  total
  limit
  page
  offset
`;